import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';

import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';

import {
  getCompanyData,
  getBusinessVatData,
} from '../../features/registration/registrationJourneySlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import {
  getBuildingAndStreet,
  getBuildingAndStreet2,
  getTownOrCity,
  getCounty,
  getPostCode,
  getLandlordOrPmcPrivateParking,
  getSelectedGrantValue,
  setInstallationAddressBuildingAndStreet,
  setInstallationAddressBuildingAndStreet2,
  setInstallationTownOrCity,
  setInstallationCounty,
  setInstallationPostCode,
} from '../../features/application/applicationJourneySlice';

import {
  checkValidBuildingAndStreet,
  checkValidTownOrCity,
  checkValidCounty,
  checkValidPostcode,
} from '../../regex/regex';
import useTitle from '../../hooks/useTitle';

const InstallationAddress = ({ location }) => {
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;
  const [errorMsgBuilding, setErrorMsgBuilding] = useState(null);
  const [errorMsgBuilding2, setErrorMsgBuilding2] = useState(null);
  const [errorMsgTownOrCity, setErrorMsgTownOrCity] = useState(null);
  const [errorMsgCounty, setErrorMsgCounty] = useState(null);
  const [errorMsgPostCode, setErrorMsgPostCode] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'landlordApp.InstallationAddress.10',
    'Enter installation address - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const companyDataRedux = useSelector(getCompanyData);
  const businessVatDataRedux = useSelector(getBusinessVatData);
  const buildingAndStreetRedux = useSelector(getBuildingAndStreet);
  const buildingAndStreet2Redux = useSelector(getBuildingAndStreet2);
  const townOrCityRedux = useSelector(getTownOrCity);
  const countyRedux = useSelector(getCounty);
  const postCodeRedux = useSelector(getPostCode);
  const currentUserData = useSelector(getUserDetails);
  const privateParkingRedux = useSelector(getLandlordOrPmcPrivateParking);
  const grantTypeSelectedObjectRedux = useSelector(getSelectedGrantValue);

  const buildingBlankError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s11',
      'Enter a building and or street'
    ),
  };

  const townOrCityBlankError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s12',
      'Enter a town or city'
    ),
  };

  const countyBlankError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s13',
      'Enter a county'
    ),
  };

  const postCodeBlankError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s14',
      'Enter a Postcode'
    ),
  };

  const buildingInvalidError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s15',
      'Enter a valid building and or street'
    ),
  };

  const townOrCityInvalidError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s16',
      'Enter a valid town or city'
    ),
  };

  const countyInvalidError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s17',
      'Enter a valid county'
    ),
  };

  const postCodeInvalidError = {
    children: copyProvider.getCopy(
      'landlordApp.InstallationAddress.s18',
      'Enter a valid postcode'
    ),
  };

  const handleBuildingAndStreet = (event) => {
    dispatch(setInstallationAddressBuildingAndStreet(event.target.value));
  };
  const handleBuildingAndStreet2 = (event) => {
    dispatch(setInstallationAddressBuildingAndStreet2(event.target.value));
  };
  const handleTownOrCity = (event) => {
    dispatch(setInstallationTownOrCity(event.target.value));
  };
  const handleCounty = (event) => {
    dispatch(setInstallationCounty(event.target.value));
  };
  const handlePostCode = (event) => {
    dispatch(setInstallationPostCode(event.target.value));
  };

  const handleBtnClick = () => {
    const errorListArr = [];
    // TODO: get approval for this if statement
    if (privateParkingRedux === 'no') {
      history.push('/landlordApp/unable-to-proceed');
    }

    let hasError = false;
    // buildingAndStreet 1
    if (buildingAndStreetRedux === '') {
      if (buildingAndStreet2Redux === '' || buildingAndStreet2Redux !== '') {
        setErrorMsgBuilding(buildingBlankError);
        errorListArr.push({ ...buildingBlankError, href: '#building-street' });
        hasError = true;
      } else if (!checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street-2',
        });
        hasError = true;
      } else if (checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(null);
      }
    } else if (!checkValidBuildingAndStreet.test(buildingAndStreetRedux)) {
      if (buildingAndStreet2Redux === '') {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(null);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else if (!checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else if (checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(null);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      }
    } else if (checkValidBuildingAndStreet.test(buildingAndStreetRedux)) {
      if (
        !checkValidBuildingAndStreet.test(buildingAndStreet2Redux) &&
        buildingAndStreet2Redux !== ''
      ) {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(null);
      }
    } else if (buildingAndStreet2Redux === '') {
      if (buildingAndStreetRedux === '') {
        setErrorMsgBuilding(buildingBlankError);
        setErrorMsgBuilding2(buildingBlankError);
        errorListArr.push({ ...buildingBlankError, href: '#building-street' });
        hasError = true;
      } else if (!checkValidBuildingAndStreet.test(buildingAndStreetRedux)) {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(null);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
      } else if (checkValidBuildingAndStreet.test(buildingAndStreetRedux)) {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(null);
      }
    } else if (!checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
      if (buildingAndStreetRedux === '') {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else if (!checkValidBuildingAndStreet.test(buildingAndStreetRedux)) {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else if (checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(buildingInvalidError);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street-2',
        });
        hasError = true;
      }
    } else if (checkValidBuildingAndStreet.test(buildingAndStreet2Redux)) {
      if (
        !checkValidBuildingAndStreet.test(buildingAndStreetRedux) &&
        buildingAndStreetRedux !== ''
      ) {
        setErrorMsgBuilding(buildingInvalidError);
        setErrorMsgBuilding2(null);
        errorListArr.push({
          ...buildingInvalidError,
          href: '#building-street',
        });
        hasError = true;
      } else {
        setErrorMsgBuilding(null);
        setErrorMsgBuilding2(null);
      }
    }
    // townOrCity
    if (townOrCityRedux === '') {
      setErrorMsgTownOrCity(townOrCityBlankError);
      errorListArr.push({ ...townOrCityBlankError, href: '#Town-or-city' });
      hasError = true;
    } else if (!checkValidTownOrCity.test(townOrCityRedux)) {
      setErrorMsgTownOrCity(townOrCityInvalidError);
      errorListArr.push({ ...townOrCityInvalidError, href: '#Town-or-city' });
      hasError = true;
    } else {
      setErrorMsgTownOrCity(null);
    }
    // county
    if (countyRedux === '') {
      setErrorMsgCounty(countyBlankError);
      errorListArr.push({ ...countyBlankError, href: '#County' });
      hasError = true;
    } else if (!checkValidCounty.test(countyRedux)) {
      setErrorMsgCounty(countyInvalidError);
      errorListArr.push({ ...countyInvalidError, href: '#County' });
      hasError = true;
    } else {
      setErrorMsgCounty(null);
    }
    // postCode
    if (postCodeRedux === '') {
      setErrorMsgPostCode(postCodeBlankError);
      errorListArr.push({ ...postCodeBlankError, href: '#Postcode' });
      hasError = true;
    } else if (!checkValidPostcode.test(postCodeRedux)) {
      setErrorMsgPostCode(postCodeInvalidError);
      errorListArr.push({ ...postCodeInvalidError, href: '#Postcode' });
      hasError = true;
    } else {
      setErrorMsgPostCode(null);
    }

    if (!hasError) {
      if (privateParkingRedux === 'yes' && isFromCheckAnswers) {
        history.push('/landlordApp/check-your-answers');
      } else if (
        privateParkingRedux === 'yes' &&
        grantTypeSelectedObjectRedux.grantTypeShort === 'commercial properties'
      ) {
        history.push('/landlordApp/parking-type');
      } else if (
        privateParkingRedux === 'yes' &&
        grantTypeSelectedObjectRedux.grantTypeShort === 'residential properties'
      ) {
        history.push('/landlordApp/building-type');
      } else {
        history.push('/landlordApp/unable-to-proceed');
      }
    } else {
      setErrorList(errorListArr);
    }
  };

  return (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <span className="govuk-caption-xl">
        {companyDataRedux && companyDataRedux.name}
        {businessVatDataRedux && businessVatDataRedux.target.name}
        {currentUserData != null &&
          currentUserData.business_name != null &&
          currentUserData.business_name}
      </span>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordApp.InstallationAddress.s1',
          'Enter the address where chargepoints will be installed'
        )}
      </h1>
      <Input
        errorMessage={errorMsgBuilding}
        id="building-street"
        label={{
          children: [
            <span key="0" className="govuk-label">
              {copyProvider.getCopy(
                'landlordApp.InstallationAddress.s2',
                'Building and street'
              )}
            </span>,
            <span key="1" className="govuk-visually-hidden">
              {copyProvider.getCopy(
                'landlordApp.InstallationAddress.s2a',
                'line 1 of 2 '
              )}
            </span>,
          ],
        }}
        value={buildingAndStreetRedux}
        onChange={(event) => handleBuildingAndStreet(event)}
        name="building-street"
        type="text"
      />

      <Input
        errorMessage={errorMsgBuilding2}
        id="building-street-2"
        // idPrefix="input-fields-installation-address"
        label={{
          children: (
            <span key="2" className="govuk-visually-hidden">
              {copyProvider.getCopy(
                'landlordApp.InstallationAddress.s2b',
                'Building and street line 2 of 2'
              )}
            </span>
          ),
        }}
        value={buildingAndStreet2Redux}
        onChange={(event) => handleBuildingAndStreet2(event)}
        name="building-street"
        type="text"
      />

      <Input
        errorMessage={errorMsgTownOrCity}
        id="Town-or-city"
        label={{
          children: copyProvider.getCopy(
            'landlordApp.InstallationAddress.s3',
            'Town or city'
          ),
        }}
        value={townOrCityRedux}
        onChange={(event) => handleTownOrCity(event)}
        name="Town-or-city"
        type="text"
      />

      <Input
        errorMessage={errorMsgCounty}
        formGroup={{
          className: 'govuk-!-width-two-thirds',
        }}
        id="County"
        label={{
          children: copyProvider.getCopy(
            'landlordApp.InstallationAddress.s4',
            'County'
          ),
        }}
        value={countyRedux}
        onChange={(event) => handleCounty(event)}
        name="County"
        type="text"
      />

      <Input
        errorMessage={errorMsgPostCode}
        formGroup={{
          className: 'govuk-input--width-10',
        }}
        id="Postcode"
        label={{
          children: copyProvider.getCopy(
            'landlordApp.InstallationAddress.s5',
            'Postcode'
          ),
        }}
        value={postCodeRedux}
        onChange={(event) => handlePostCode(event)}
        name="Postcode"
        type="text"
      />

      <Button className="govuk-button-group" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordApp.InstallationAddress.s9', 'Continue')}
      </Button>
    </>
  );
};

InstallationAddress.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

InstallationAddress.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};

export default InstallationAddress;
